<script setup>
    import { copyToClipboard } from '../helpers/common.js';
    import Qrious from 'qrious';
    import { onMounted, ref, watch } from "vue";
    import { usePortalContentAndDesignStore } from "../stores/partners/portalContentAndDesignStore";

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const props = defineProps({
        content: { type: String },
        name: {
            type: String,
            default: 'image'
        },
        buttonType: {
            type: String,
            default: ''
        }
    })

    const qrElement = ref(null);
    const qrRender = ref(null);
    const delay = ref(null);
    const isCopied = ref(false);

    const makeQR = () => {
        if (qrRender.value) {
            qrRender.value.value = props.content;
        }
    }

    onMounted(() => {
        qrRender.value = new Qrious({
            element: qrElement.value,
            padding: 10,
            size: 500,
        });

        makeQR();
    });

    watch(() => props.content, () => {
        clearTimeout(delay.value);
        delay.value = setTimeout(() => makeQR(), 300);
    });

    const download = () => {
        let a = document.createElement("a");
        a.href = qrElement.value.src
        a.download = `qrcode_${props.name}.png`;
        a.click();
    }

    const copyEmbed = () => {
        let text = qrElement.value.outerHTML;
        isCopied.value = copyToClipboard(text);
        setTimeout(() => isCopied.value = false, 2000);
    }

    const print = () => {
        let printWindow = window.open("about:blank", "_blank");
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head></head>
                <body onload="setTimeout(function() { window.print(); window.close(); }, 10);">
                    <img src="${qrElement.value.src}" />
                </body>
            </html>
        `);
        printWindow.document.close();
    }
</script>

<template>
    <div>
        <p>{{ portalContentAndDesignStore.translationSettings.portal_translation_feature_qr_code_text }}</p>
    </div>

    <div class="flex items-center p-5 sm:p-9 bg-gradient-to-t from-gray-50 rounded-md -mx-5 -mb-6 sm:-mx-9 sm:-mb-8 rounded-b-none border-b text-sm">
        <div class="h-40 w-40 flex-shrink-0 mr-6 p-4 rounded-md bg-white border border-gray-200">
            <img ref="qrElement" id="qrcode" alt="qrImg">
        </div>

        <ul class="flex-1 flex flex-col divide-y divide-gray-200">
            <li>
                <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md" @click="download">
                    <div class="flex items-center space-x-2">
                        <icon name="download" />
                        <span>{{ portalContentAndDesignStore.translationSettings.portal_translation_general_download }}</span>
                    </div>
                </button>
            </li>
            <li>
                <modal
                    :title="portalContentAndDesignStore.translationSettings.portal_translation_general_embed_code"
                    :cancel_btn_title="portalContentAndDesignStore.translationSettings.portal_translation_general_cancel"
                    size="small"
                >
                    <template #toggle>
                        <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md">
                            <div class="flex items-center space-x-2">
                                <icon name="code" />
                                <span>{{ portalContentAndDesignStore.translationSettings.portal_translation_general_embed_code }}</span>
                            </div>
                        </button>
                    </template>
                    <template #body>
                        <div class="space-y-4">
                            <text-field :model-value="qrElement.outerHTML" readonly="true"></text-field>
                            <div class="ml-1" v-if="isCopied">{{ portalContentAndDesignStore.translationSettings.portal_translation_general_copied }}</div>
                        </div>
                    </template>
                    <template #footer>
                        <btn :type="buttonType" @click="copyEmbed">{{ portalContentAndDesignStore.translationSettings.portal_translation_general_cancel }}</btn>
                    </template>
                </modal>
            </li>
            <li>
                <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md" @click="print">
                    <div class="flex items-center space-x-2">
                        <icon name="printer" />
                        <span>{{ portalContentAndDesignStore.translationSettings.portal_translation_general_print }}</span>
                    </div>
                </button>
            </li>
        </ul>

    </div>
</template>
